import { gql } from '@apollo/client'

export const GET_PLAN_DATA_GQL = gql(/* GraphQL */`
  query GetPlanData {
    myEnterprise {
      id
      subscription {
        ... on BillingSubscriptionActive {
          id
          plan {
            id
            name
            price
            interval {
              unit
              count
            }
            product {
              id
              name
              description
              features {
                __typename
                # Team Members
                ... on SubscriptionFeatureTeam {
                  limits {
                    value
                    interval
                  }
                }
                # Lead List Exports
                ... on SubscriptionFeatureLeads {
                  limits {
                    interval
                    value
                  }
                  usages {
                    interval
                    value
                    nextRolloverDate
                  }
                }
                # Comps
                ... on SubscriptionFeatureComps {
                  limits {
                    interval
                    value
                  }
                  usages {
                    interval
                    value
                    nextRolloverDate
                  }
                  prices {
                    price
                    pricingUnit
                    pricingUnitDescription
                    included {
                      limit
                      used
                      nextRolloverDate
                    }
                  }
                }
                # Skiptrace
                ... on SubscriptionFeatureSkiptrace {
                  limits {
                    interval
                    value
                  }
                  usages {
                    interval
                    value
                    nextRolloverDate
                  }
                  prices {
                    price
                    pricingUnit
                    pricingUnitDescription
                    included {
                      limit
                      used
                      nextRolloverDate
                    }
                  }
                }
                # Basic Individual Skiptrace
                ... on SubscriptionFeatureIndividualSkiptrace {
                  limits {
                    interval
                    value
                  }
                  usages {
                    interval
                    value
                    nextRolloverDate
                  }
                  prices {
                    price
                    pricingUnit
                    pricingUnitDescription
                    included {
                      limit
                      used
                      nextRolloverDate
                    }
                  }
                }
                # Direct Mail
                ... on SubscriptionFeatureDirectMail {
                  limits {
                    interval
                    value
                  }
                  usages {
                    interval
                    value
                    nextRolloverDate
                  }
                  prices {
                    price
                    pricingUnit
                    pricingUnitDescription
                    included {
                      limit
                      used
                      nextRolloverDate
                    }
                  }
                }
                # Websites
                ... on SubscriptionFeatureWebsites {
                  limits {
                    interval
                    value
                  }
                }
                # Property Lookup
                ... on SubscriptionFeaturePropertyLookup {
                  limits {
                    interval
                    value
                  }
                  usages {
                    interval
                    value
                    nextRolloverDate
                  }
                  productId
                }
              }
            }
          }
          currentPeriod {
            end
          }
          trialPeriod {
            end
          }
          cancelAt
          cancelAtPeriodEnd
        }
        ... on BillingSubscriptionInactive {
          id
        }
      }
      wallet {
        balance {
          available
        }
      }
    }
  }
`)
